import { createImmutableObjectClass } from 'immutable-less';
export default class FieldDataIdentifier extends createImmutableObjectClass({
  actionId: null,
  dataKey: null,
  type: null
}) {
  /**
   * @deprecated Prefer dot notation: .actionId
   */
  getActionId() {
    return this.actionId;
  }
  /**
   * @deprecated Prefer dot notation: .dataKey
   */
  getDataKey() {
    return this.dataKey;
  }
  /**
   * @deprecated Prefer dot notation: .type
   */
  getType() {
    return this.type;
  }
}